export default async container => { // 'comp-timeline'
	const 	{default: ScrollMagic} = await import('scrollmagic'),
			{default: Masonry} = await import('masonry-layout'),
			controller = new ScrollMagic.Controller(),
			MasonryContainer = new Masonry(container,{
				itemSelector: '[card]',
				columnWidth: '[sizer]',
				percentPosition: true
			});
	MasonryContainer.on('layoutComplete', updateAlignment);
	[...container.querySelectorAll('[card]')].forEach(item => {
		(new ScrollMagic.Scene({triggerElement: item, triggerHook: 0.9})
		.on("enter", function () {
			item.classList.add('inview');
		})
		.addTo(controller));
		[...item.querySelectorAll('img')].forEach(img => img.addEventListener('load',() => MasonryContainer.layout()));
	});
	updateAlignment();
	function updateAlignment(){
		[...container.querySelectorAll('[card]')].forEach(item => {
			let children = [...item.children];
			children.forEach(child => child.classList.remove('left'));
			if(parseInt(item.style.left) === 0) {
				children.forEach(child => child.classList.add('left'));
			}
		});
	}
};